module.exports = __webpack_public_path__ + "static/media/swap_img.91de9f5d.png";